import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Main from './(pages)/main/page'

const MoreInfo = () => {
  return (
    <Routes>
        <Route path="*" element={<Main />}/>
    </Routes>
  )
}

export default MoreInfo